import script from "./Krediflow-Settings-Users.vue?vue&type=script&setup=true&lang=js"
export * from "./Krediflow-Settings-Users.vue?vue&type=script&setup=true&lang=js"

import "./Krediflow-Settings-Users.vue?vue&type=style&index=0&id=746c241f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-746c241f"]])

export default __exports__